class QueryStringUtil {
  #dictionary: {
    [key: string]: string | boolean
  } = {}
  constructor() {
    let query = window.location.href.substring(window.location.href.indexOf('?') + 1, window.location.href.length)

    if (query.indexOf('#') !== -1) {
      query = query.substring(0, query.indexOf('#'))
    }

    const vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=')
      const key = decodeURIComponent(pair[0])
      const val = decodeURIComponent(pair[1])
      this.#dictionary[key] = val || true // true so "?x"; if( query.x ){}
    }
  }

  get(id: string): string | boolean {
    return this.#dictionary[id]
  }
}

export default new QueryStringUtil()
